import { RefObject, useCallback, useEffect } from "react";

export const useOnScrolledToTop = (
  isLoading: boolean,
  isLoadingMore: boolean,
  canLoadMore: boolean,
  loadedLength: number,
  scrollContainer: RefObject<HTMLDivElement>,
  setRequest: React.Dispatch<React.SetStateAction<any>>
) => {
  const onScrolledToTop = useCallback(() => {
    canLoadMore &&
      setRequest({
        take: 50,
        skip: loadedLength,
      });
  }, [loadedLength, canLoadMore, setRequest]);

  const eventHandler = useCallback(
    (event: any) => {
      if (event.target?.scrollTop === 0 && !isLoadingMore) {
        onScrolledToTop();
      }
    },
    [isLoadingMore, onScrolledToTop]
  );

  useEffect(() => {
    let elem: any;
    if (!isLoading && scrollContainer) {
      elem = scrollContainer.current;

      elem.addEventListener("scroll", eventHandler);
    }

    return () => {
      elem && elem.removeEventListener("scroll", eventHandler);
    };
  }, [isLoading, eventHandler, scrollContainer]);
};
